export function getUserId() {
  return localStorage.getItem('ssoUserId') || '';
}
